module.exports = __webpack_public_path__ + "img/rain.63adf361.jpg";